<p>
  contact-notes-dialig works!
</p>
